'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TALON_INITIAL_VALUE = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jQuery = require('jQuery');

var _jQuery2 = _interopRequireDefault(_jQuery);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRhumb = require('react-rhumb');

var _AnalyticsActions = require('../actions/AnalyticsActions');

var _HubsActions = require('../actions/HubsActions');

var _TalonActions = require('../actions/TalonActions');

var _UtmActions = require('../actions/UtmActions');

var _Header = require('../components/Header');

var _Header2 = _interopRequireDefault(_Header);

var _Page = require('../components/Page');

var _Page2 = _interopRequireDefault(_Page);

var _QueryParamsContainer = require('../globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _Config = require('../selectors/Config');

var _Steps = require('../selectors/Steps');

var _UsageTrackerContainer = require('../tracking/UsageTrackerContainer');

var _UsageTrackerContainer2 = _interopRequireDefault(_UsageTrackerContainer);

var _isNewSignupUx = require('../utils/isNewSignupUx');

var _isNewSignupUx2 = _interopRequireDefault(_isNewSignupUx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LOG = _Logger2.default.getLogger('Application');

var TALON_INITIAL_VALUE = exports.TALON_INITIAL_VALUE = '{"version": 5, "status": -1}';

var Application = function (_React$Component) {
  _inherits(Application, _React$Component);

  function Application() {
    _classCallCheck(this, Application);

    return _possibleConstructorReturn(this, (Application.__proto__ || Object.getPrototypeOf(Application)).apply(this, arguments));
  }

  _createClass(Application, [{
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {
      // Removes the page loading node from the initial html payload.
      // See html/mixins/page-not-loading-screen
      (0, _jQuery2.default)('#page-not-loading').remove();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var location = this.props.location;


      this.props.parseUtmData(location.query);
      this.props.parseHubsData(location.query);
      (0, _AnalyticsActions.trackEvent)('interaction', { action: 'Application container mounted' });
      this.reInitTrackerAfterAnalyticsLoad();
      this.updateTalon();
    }
  }, {
    key: 'updateTrackerConfig',
    value: function updateTrackerConfig() {
      var params = this.props.params;


      var updatedUsageTrackerConfig = void 0;
      // re-init logger with the email and portal as early as possible.
      var email = _QueryParamsContainer2.default.get('email');
      if (email || params.portalid) {
        // new tracker
        updatedUsageTrackerConfig = {
          namespace: 'signup',
          email: email,
          hubId: params.portalid,
          hstc: _UsageTrackerContainer.getTrackerHstc
        };
      } else {
        // set the appname as fast as possible
        // new tracker
        updatedUsageTrackerConfig = {
          namespace: 'signup',
          hstc: _UsageTrackerContainer.getTrackerHstc
        };
      }

      if (updatedUsageTrackerConfig) {
        // new tracker
        _UsageTrackerContainer2.default.setProperties(updatedUsageTrackerConfig);
      }
    }
  }, {
    key: 'reInitTrackerAfterAnalyticsLoad',
    value: function reInitTrackerAfterAnalyticsLoad() {
      var _this2 = this;

      window._hsq = window._hsq || [];
      window._hsq.push(['addCookieListener', function (utk) {
        if (utk) {
          _this2.updateTrackerConfig();
        }
      }]);
    }
  }, {
    key: 'updateTalon',
    value: function updateTalon() {
      this.waitForTalonScript();
      this.waitForTalonValue();
    }
  }, {
    key: 'waitForTalonScript',
    value: function waitForTalonScript() {
      var interval = setInterval(function () {
        try {
          if (window.hasOwnProperty('eHawkTalon')) {
            window.eHawkTalon();
            clearInterval(interval);
          }
        } catch (error) {
          LOG.error('Could not execute talon script', {
            extra: {
              error: error
            }
          });
        }
      }, 1000);

      setTimeout(function () {
        clearInterval(interval);
      }, 10000);
    }
  }, {
    key: 'waitForTalonValue',
    value: function waitForTalonValue() {
      var _this3 = this;

      // eHawk script has an internal timeout, here I wait til the input is filled with a non-default value
      // or I timeout after 600 millis (usually I get the value right after 350,400 millis, 600 seems a good tradeoff
      // then dispatch the action
      var interval = setInterval(function () {
        var talonValue = _this3.getTalonValue();
        if (talonValue && !talonValue.includes(TALON_INITIAL_VALUE)) {
          clearInterval(interval);
          _this3.props.updateTalonValue(talonValue);
        }
      }, 1000);

      setTimeout(function () {
        clearInterval(interval);
      }, 10000);
    }
  }, {
    key: 'getTalonValue',
    value: function getTalonValue() {
      var talon = document.getElementById('talon');
      var talonValue = null;
      if (talon) {
        talonValue = talon.value;
      }
      return talonValue;
    }
  }, {
    key: 'renderTalonHiddenInput',
    value: function renderTalonHiddenInput() {
      return _react2.default.createElement('input', {
        type: 'hidden',
        name: 'talon',
        value: TALON_INITIAL_VALUE,
        id: 'talon'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          currentStep = _props.currentStep;


      if (!children) {
        // Use 404?
        return null;
      }

      return _react2.default.createElement(
        'div',
        {
          id: 'signup-app',
          className: (0, _classnames2.default)(_defineProperty({
            'signup-app-white': (0, _isNewSignupUx2.default)() || (0, _Config.getIsEmbeddedContentFlow)()
          }, 'signup-app-step-' + currentStep, !!currentStep))
        },
        _react2.default.createElement(_reactRhumb.NavMarker, { name: 'INDEX_LOADED' }),
        _react2.default.createElement(_Header2.default, { params: this.props.params }),
        this.renderTalonHiddenInput(),
        _react2.default.createElement(
          _Page2.default,
          null,
          children
        )
      );
    }
  }]);

  return Application;
}(_react2.default.Component);

Application.propTypes = {
  children: _propTypes2.default.any,
  currentStep: _propTypes2.default.string,
  location: _propTypes2.default.object,
  params: _propTypes2.default.object,
  parseUtmData: _propTypes2.default.func.isRequired,
  parseHubsData: _propTypes2.default.func.isRequired,
  updateTalonValue: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
  return { currentStep: (0, _Steps.getCurrentStepKey)(state) };
};

var mapDispatchToProps = {
  parseUtmData: _UtmActions.parseUtmData,
  parseHubsData: _HubsActions.parseHubsData,
  updateTalonValue: _TalonActions.updateTalonValue
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Application);